import { render, staticRenderFns } from "./emagLoginComponent.vue?vue&type=template&id=10633c4a&scoped=true"
import script from "./emagLoginComponent.vue?vue&type=script&lang=js"
export * from "./emagLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./emagLoginComponent.vue?vue&type=style&index=0&id=10633c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10633c4a",
  null
  
)

export default component.exports